import React, { useState, useEffect, useCallback } from 'react';
import { fetchLoginRecords, deleteLoginRecord } from '../../api/api';
import DataTable from '../DataTable/DataTable';
import Pagination from '../Pagination/Pagination';
import Modal from '../Modal/Modal';
import Spinner from '../../assets/spinner.svg';

const LoginRecordsPage = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const loadRecords = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchLoginRecords(currentPage);
      setRecords(data.results);
      setTotalPages(data.totalPages);
    } catch (err) {
      setError('Failed to fetch login records.');
    } finally {
      setLoading(false);
    }
  }, [currentPage]);

  useEffect(() => {
    loadRecords();
  }, [loadRecords]);
  
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  
  // Edit is disabled for login records as it's typically read-only
  const handleEdit = (record) => {
    alert(`Editing is disabled for login records.`);
  };

  const handleDeleteRequest = (id) => {
    setItemToDelete(id);
    setIsModalOpen(true);
  };
  
  const confirmDelete = async () => {
    if (itemToDelete) {
      await deleteLoginRecord(itemToDelete);
      setIsModalOpen(false);
      setItemToDelete(null);
      loadRecords();
    }
  };

  const columns = [
    { header: 'User Name', accessor: 'user.name' },
    { header: 'User Phone', accessor: 'user.phone' },
    { header: 'IP Address', accessor: 'ipAddress' },
    { header: 'Login Time', accessor: 'loginTime', isDate: true },
  ];

  if (loading) {
    return <div className="loading-spinner"><img src={Spinner} alt="Loading..." /></div>;
  }

  if (error) {
    return <div className="no-data-message">{error}</div>;
  }

  return (
    <div>
      <h1 className="page-header">Login History</h1>
      {records.length > 0 ? (
        <>
          <DataTable 
            data={records} 
            columns={columns} 
            onEdit={handleEdit}
            onDelete={handleDeleteRequest}
          />
          <Pagination 
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        <div className="no-data-message">No login records found.</div>
      )}
      <Modal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={confirmDelete}
        title="Confirm Deletion"
      >
        <p>Are you sure you want to delete this login record? This action cannot be undone.</p>
      </Modal>
    </div>
  );
};

export default LoginRecordsPage;